export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-11.png?eb047bdf912107b40599bfe8bbddf7ab";